(() => {
  if (customElements.get('autodiaz-footer-legal')) return;
  class FooterLegal extends HTMLElement {
    constructor() {
      super();
      this.onHashChange = () => {
        if (window.location.hash === '#politica-de-cookies') this.showPolicy();
      };
    }
    connectedCallback() {
      if (!this.policyDialog) {
        const content = this.querySelector('#politica-de-cookies');
        const dialog = document.createElement('dialog');
        if (content && typeof dialog.showModal === 'function') {
          dialog.className = 'ad-cookie-policy-dialog';
          dialog.setAttribute('aria-labelledby', 'ad-cookie-policy-title');
          const fallback = content.closest('details');
          content.querySelector('[data-ad-close-cookie-policy]').hidden = false;
          dialog.append(content);
          fallback.remove();
          this.append(dialog);
          this.policyDialog = dialog;
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          });
        }
      }
      this.addEventListener('click', this.onClick);
      window.addEventListener('hashchange', this.onHashChange);
      this.onHashChange();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('hashchange', this.onHashChange);
    }
    showPolicy() {
      if (!this.policyDialog || this.policyDialog.open) return;
      this.policyDialog.showModal();
      this.policyDialog.scrollTop = 0;
    }
    onClick(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (event.target.closest('[data-ad-cookie-policy-open]') && this.policyDialog) {
        event.preventDefault();
        this.showPolicy();
        return;
      }
      if (event.target.closest('[data-ad-close-cookie-policy]')) {
        this.policyDialog?.close();
        return;
      }
      const link = event.target.closest('[data-ad-cookie-preferences]');
      const banner = window.privacyBanner;
      if (!link || typeof banner?.showPreferences !== 'function') return;
      try {
        this.policyDialog?.close();
        const opened = banner.showPreferences();
        event.preventDefault();
        Promise.resolve(opened).catch(() => window.location.assign(link.href));
      } catch (error) {
        return;
      }
    }
  }
  customElements.define('autodiaz-footer-legal', FooterLegal);
})();
